// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default .opl-widget-chat--messages{list-style:none;margin:0px 0px;padding:20px 15px}.default .opl-widget-chat--messages>li:first-child{margin-top:0px}.default .opl-widget-chat--messages--header{padding-top:29px;padding-bottom:20px;text-align:center}.mojorange .opl-widget-chat--messages{padding:10px 25px}", ""]);
// Exports
module.exports = exports;
